import { useLayoutEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IS_CASINO_FUN_MODE_DISABLED } from 'utils/constants/casino/casino-constants';
import { getCasinoParams } from 'utils/generic/route-manipulation';
import { ECasinoGameMode } from 'interfaces/casino-data';
import { addQuery } from 'components/QueryRoute';
import { useSearchParams } from 'hooks/useSearchParams';
import { setCachedGameMode } from 'store/actions/new-casino';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';
import { ConstantsCasino } from '../../../constants';
import { UtilsCasino } from '../../utils';

export const SingleviewModeChecker = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { mode } = useSearchParams();
  const user = useSelector(getUser);
  const isLoggedIn = useSelector(getIsLoggedIn);

  const routeLength = useMemo(
    () => UtilsCasino.getRouteLength(),
    [history.location?.search, history.location?.pathname]
  );

  useLayoutEffect(() => {
    const { gameExternalId } = getCasinoParams();

    const changeModeToReal = () => {
      history.push(
        addQuery({
          mode: ECasinoGameMode.REAL
        })
      );
      dispatch(
        setCachedGameMode({
          id: gameExternalId,
          mode: ECasinoGameMode.REAL
        })
      );
    };

    if (
      IS_CASINO_FUN_MODE_DISABLED &&
      !isLoggedIn &&
      !user.pending &&
      mode !== ECasinoGameMode.REAL
    ) {
      // in case when user opens casino game with fun mode and partner turned off fun mode, we should redirect to real mode and after that will be opened login popup and automatically
      // in case when opened register or reset password popup, after login popup change the prev location will be saved with search and after closing popups mode will be real, in that cases mode is undefined and no need to uapdte
      if (mode === ECasinoGameMode.FUN) {
        history.push(addQuery({ mode: 'real' }));
      }
    } else if (
      routeLength !== undefined &&
      routeLength > ConstantsCasino.ROUTE_LENGTH_WITHOUT_PROVIDER
    ) {
      if (!mode) {
        const finalMode = IS_CASINO_FUN_MODE_DISABLED
          ? ECasinoGameMode.REAL
          : ECasinoGameMode.FUN;

        history.push(
          addQuery({
            mode: finalMode
          })
        );
        dispatch(
          setCachedGameMode({
            id: gameExternalId,
            mode: finalMode
          })
        );

        return;
      }

      if (mode !== ECasinoGameMode.REAL && IS_CASINO_FUN_MODE_DISABLED) {
        changeModeToReal();
      }
    }
  }, [isLoggedIn, user.pending, mode, routeLength]);

  return null;
};
